import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApisMembersAnalysisCumulativeOfPostsIndexRequestTypes,
  ApisMembersAnalysisCumulativeOfPostsIndexResponseTypes,
} from "~/domains";

type RequestDataType = {
  params: ApisMembersAnalysisCumulativeOfPostsIndexRequestTypes;
};

const request = async ({
  params,
}: RequestDataType): Promise<ApisMembersAnalysisCumulativeOfPostsIndexResponseTypes> => {
  const response =
    await new ApiClient().get<ApisMembersAnalysisCumulativeOfPostsIndexResponseTypes>(
      "/api/members/analysis/cumulative_of_posts",
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params: ApisMembersAnalysisCumulativeOfPostsIndexRequestTypes;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersAnalysisCumulativeOfPostsIndex = ({
  params,
  config = {},
}: PropsType): UseQueryResult<ApisMembersAnalysisCumulativeOfPostsIndexResponseTypes> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisMembersAnalysisCumulativeOfPostsIndex", params],
    queryFn: () => request({ params }),
  });
};
